// test1063
(1063 && 0);
